<div class="px-3 pt-2">
    <!-- Company and Branch Selection - Only for Admin Users -->
    <div *ngIf="accountService.isAdmin()" class="mb-2 rounded-2 shadow-sm" style="border:1px solid #e0e6ef; background:#fff; overflow:hidden;">
        <div class="px-3 py-1" style="background:#f8f9fa; border-bottom:1px solid #e0e6ef;">
            <span class="fw-semibold" style="font-size:12px; color:#1e3a5f; text-transform:uppercase; letter-spacing:.4px;">Company &amp; Branch</span>
        </div>
        <div class="px-3 py-2">
            <app-company-branch-selector 
                (selectionReady)="onSelectionReady($event)"
                (companyChange)="onCompanyChange($event)"
                (branchChange)="onBranchChange($event)">
            </app-company-branch-selector>
        </div>
    </div>

    <!-- Dashboard Stats Cards - ERP roles -->
    <div *ngIf="!accountService.isTransporter()" class="dashboard-stats mb-2">
        <!-- Date Range Selector -->
        <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
            <select class="form-select date-range-select" [(ngModel)]="selectedDateRange" (change)="onDateRangeChange()">
                <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
            </select>
            <!-- Custom Date Range Inputs -->
            <ng-container *ngIf="selectedDateRange === 'custom'">
                <label class="mb-0" style="font-size:11px; white-space:nowrap; color:#8a94a0;">From</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="customStartDate" (change)="onDateRangeChange()" style="width:130px;" />
                <label class="mb-0" style="font-size:11px; white-space:nowrap; color:#8a94a0;">To</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="customEndDate" (change)="onDateRangeChange()" style="width:130px;" />
            </ng-container>
        </div>

        <!-- Stats Grid — all 8 cards, 4 per row on large screens -->
        <div class="row g-2">
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-4">
                    <div class="stat-title">Total Sales</div>
                    <div class="stat-value" *ngIf="!isLoadingDateStats">₹{{ dateFilteredStats.totalSales | indianCurrency:0 }}</div>
                    <div class="stat-value" *ngIf="isLoadingDateStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-5">
                    <div class="stat-title">Items Sold</div>
                    <div class="stat-value" *ngIf="!isLoadingDateStats">{{ dateFilteredStats.totalItemQty | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingDateStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-7">
                    <div class="stat-title">Returns</div>
                    <div class="stat-value" *ngIf="!isLoadingDateStats">{{ dateFilteredStats.totalExchanges | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingDateStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-8">
                    <div class="stat-title">Purchase Qty</div>
                    <div class="stat-value" *ngIf="!isLoadingDateStats">{{ dateFilteredStats.totalPurchaseQty | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingDateStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-1">
                    <div class="stat-title">Stock MRP</div>
                    <div class="stat-value" *ngIf="!isLoadingStaticStats">₹{{ staticStats.stockValue | indianCurrency:2 }}</div>
                    <div class="stat-value" *ngIf="isLoadingStaticStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-3">
                    <div class="stat-title">Stock Cost</div>
                    <div class="stat-value" *ngIf="!isLoadingStaticStats">₹{{ staticStats.stockCostValue | indianCurrency:2 }}</div>
                    <div class="stat-value" *ngIf="isLoadingStaticStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-2">
                    <div class="stat-title">Stock Qty</div>
                    <div class="stat-value" *ngIf="!isLoadingStaticStats">{{ staticStats.stockQuantity | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingStaticStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-6">
                    <div class="stat-title">Outstanding</div>
                    <div class="stat-value" *ngIf="!isLoadingStaticStats">₹{{ staticStats.outstandingAmount | indianCurrency:0 }}</div>
                    <div class="stat-value" *ngIf="isLoadingStaticStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
        </div>
    </div>

    <!-- Dashboard Stats Cards - Transporter role -->
    <div *ngIf="accountService.isTransporter()" class="dashboard-stats mb-2">
        <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
            <select class="form-select date-range-select" [(ngModel)]="selectedDateRange" (change)="onDateRangeChange()">
                <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
            </select>
            <ng-container *ngIf="selectedDateRange === 'custom'">
                <label class="mb-0" style="font-size:11px; white-space:nowrap; color:#8a94a0;">From</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="customStartDate" (change)="onDateRangeChange()" style="width:130px;" />
                <label class="mb-0" style="font-size:11px; white-space:nowrap; color:#8a94a0;">To</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="customEndDate" (change)="onDateRangeChange()" style="width:130px;" />
            </ng-container>
        </div>
        <div class="row g-2">
            <div class="col-lg col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-4">
                    <div class="stat-title">Receipts</div>
                    <div class="stat-value" *ngIf="!isLoadingTransporterStats">{{ transporterStats.receiptCount | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingTransporterStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-5">
                    <div class="stat-title">Total Weight (MT)</div>
                    <div class="stat-value" *ngIf="!isLoadingTransporterStats">{{ transporterStats.totalWeight | number:'1.2-2' }}</div>
                    <div class="stat-value" *ngIf="isLoadingTransporterStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-7">
                    <div class="stat-title">Total Freight</div>
                    <div class="stat-value" *ngIf="!isLoadingTransporterStats">₹{{ transporterStats.totalFreight | indianCurrency:0 }}</div>
                    <div class="stat-value" *ngIf="isLoadingTransporterStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-8">
                    <div class="stat-title">Payments</div>
                    <div class="stat-value" *ngIf="!isLoadingTransporterStats">{{ transporterStats.paymentCount | number:'1.0-0' }}</div>
                    <div class="stat-value" *ngIf="isLoadingTransporterStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
            <div class="col-lg col-md-4 col-sm-6 col-6">
                <div class="stat-card stat-card-6">
                    <div class="stat-title">Payment Amount</div>
                    <div class="stat-value" *ngIf="!isLoadingTransporterStats">₹{{ transporterStats.totalPaymentAmount | indianCurrency:0 }}</div>
                    <div class="stat-value" *ngIf="isLoadingTransporterStats"><span class="spinner-border spinner-border-sm"></span></div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-2">
        <div class="d-flex align-items-center mb-2" style="gap:6px;">
            <i class="bi bi-calendar3" style="font-size:14px; color:#1e3a5f;"></i>
            <span class="fw-semibold" style="font-size:13px; color:#1e3a5f; text-transform:uppercase; letter-spacing:.4px;">Day-wise Closing</span>
        </div>

        <div class="border rounded overflow-hidden">
            <div style="overflow-x: auto;">
                <div style="overflow-y: auto; max-height: calc(100vh - 280px);">

                    <!-- Table for Transport Users -->
                    <table *ngIf="accountService.isTransporter()" class="table table-bordered table-hover table-sm mb-0 compact-table"
                              style="min-width: 850px; width: 100%; font-size: 12px; border-color: #ccc; table-layout: auto;">
                        <thead style="position: sticky; top: 0; z-index: 2;">
                            <tr class="fw-semibold text-white" style="background: #1e3a5f; line-height:1.2; font-size:12px; white-space:nowrap;">
                                <th class="px-2">Date</th>
                                <th class="text-center px-2">Receipts</th>
                                <th class="text-center px-2">Total Weight (MT)</th>
                                <th class="text-end px-2">Total Freight</th>
                                <th class="text-center px-2">Payments</th>
                                <th class="text-end px-2">Diesel</th>
                                <th class="text-end px-2">Advance</th>
                                <th class="text-end px-2">Payment Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="isLoading">
                                <td colspan="8" class="text-center py-4">
                                    <span class="spinner-border text-primary" role="status"></span>
                                    <span class="ms-2">Loading...</span>
                                </td>
                            </tr>
                            <tr *ngIf="!isLoading && dayWiseClosing.length === 0">
                                <td colspan="8" class="text-center text-muted py-4">No records available</td>
                            </tr>
                            <tr *ngFor="let item of dayWiseClosing; let i = index"
                                [style.background]="i % 2 === 0 ? '#f0f2f5' : '#fff'"
                                style="line-height:1; height:28px;">
                                <td class="px-2" style="white-space:nowrap;">{{ item.date | date:'dd-MMM-yyyy' }}</td>
                                <td class="text-center px-2">{{ item.receiptCount }}</td>
                                <td class="text-center px-2">{{ item.totalWeight | number:'1.2-2' }}</td>
                                <td class="text-end fw-bold text-primary px-2">₹{{ item.totalFreight | indianCurrency:0 }}</td>
                                <td class="text-center fw-bold px-2">{{ item.paymentCount }}</td>
                                <td class="text-end px-2">₹{{ item.totalDiesel | indianCurrency:0 }}</td>
                                <td class="text-end px-2">₹{{ item.totalPaymentAdvance | indianCurrency:0 }}</td>
                                <td class="text-end fw-bold text-success px-2">₹{{ item.totalPaymentAmount | indianCurrency:0 }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Table for Sales Users -->
                    <table *ngIf="!accountService.isTransporter()" class="table table-bordered table-hover table-sm mb-0 compact-table"
                           style="min-width: 900px; width: 100%; font-size: 12px; border-color: #ccc; table-layout: auto;">
                        <thead style="position: sticky; top: 0; z-index: 2;">
                            <tr class="fw-semibold text-white" style="background: #1e3a5f; line-height:1.2; font-size:12px; white-space:nowrap;">
                                <th class="px-2">Date</th>
                                <th class="text-center px-2">Sold Qty</th>
                                <th class="text-end px-2">Total Sale</th>
                                <th class="text-end px-2">Credit</th>
                                <th class="text-end px-2">Discount</th>
                                <th class="text-end px-2">Returns</th>
                                <th class="text-end px-2">CN Applied</th>
                                <th class="text-end px-2">CN Issued</th>
                                <th class="text-end px-2">Net Sales</th>
                                <th class="text-end px-2">Card</th>
                                <th class="text-end px-2">Cash</th>
                                <th class="text-end px-2">Digital</th>
                                <th class="text-end px-2">Total Transactions</th>
                                <th class="text-end px-2">Cash Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="isLoading">
                                <td colspan="14" class="text-center py-4">
                                    <span class="spinner-border text-primary" role="status"></span>
                                    <span class="ms-2">Loading...</span>
                                </td>
                            </tr>
                            <tr *ngIf="!isLoading && dayWiseClosing.length === 0">
                                <td colspan="14" class="text-center text-muted py-4">No records available</td>
                            </tr>
                            <tr *ngFor="let item of dayWiseClosing; let i = index"
                                [style.background]="i % 2 === 0 ? '#f0f2f5' : '#fff'"
                                style="line-height:1; height:28px;">
                                <td class="px-2" style="white-space:nowrap;">{{ item.date | date:'dd-MMM-yyyy' }}</td>
                                <td class="text-center px-2">{{ item.totalQuantity }}</td>
                                <td class="text-end px-2">₹{{ item.totalSale | indianCurrency:0 }}</td>
                                <td class="text-end text-danger px-2">₹{{ item.totalCredit | indianCurrency:0 }}</td>
                                <td class="text-end text-warning px-2">₹{{ item.totalDiscount | indianCurrency:0 }}</td>
                                <td class="text-end text-danger px-2">₹{{ item.totalReturns | indianCurrency:0 }}</td>
                                <td class="text-end text-warning px-2">₹{{ item.totalCreditNoteApplied | indianCurrency:0 }}</td>
                                <td class="text-end text-info px-2">₹{{ item.totalCnIssued | indianCurrency:0 }}</td>
                                <td class="text-end fw-bold text-primary px-2">₹{{ item.netSales | indianCurrency:0 }}</td>
                                <td class="text-end px-2">₹{{ item.totalCard | indianCurrency:0 }}</td>
                                <td class="text-end px-2">₹{{ item.totalCash | indianCurrency:0 }}</td>
                                <td class="text-end px-2">₹{{ item.totalDigital | indianCurrency:0 }}</td>
                                <td class="text-end px-2">₹{{ item.totalExpenses | indianCurrency:0 }}</td>
                                <td class="text-end fw-bold text-success px-2">₹{{ item.cashBalance | indianCurrency:0 }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>

        <!-- Pagination Controls -->
        <div class="d-flex justify-content-between align-items-center mt-2" *ngIf="!isLoading && dayWiseClosing.length > 0" style="font-size:12px;">
            <div>
                <small class="text-muted">
                    Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalRecords) }} of {{ totalRecords }} records
                </small>
            </div>
            <div class="pagination-controls">
                <button class="btn btn-outline-secondary btn-sm py-0 px-2 me-1" style="font-size:11px;"
                        [disabled]="currentPage === 1"
                        (click)="onPageChange(1)" title="First page" aria-label="First page"><i class="bi bi-chevron-bar-left"></i></button>
                <button class="btn btn-outline-secondary btn-sm py-0 px-2 me-1" style="font-size:11px;"
                        [disabled]="currentPage === 1" 
                        (click)="onPageChange(currentPage - 1)" title="Previous page" aria-label="Previous page"><i class="bi bi-chevron-left"></i></button>
                <span class="mx-2 text-muted" style="font-size:11px;">Page {{ currentPage }} / {{ totalPages }}</span>
                <button class="btn btn-outline-secondary btn-sm py-0 px-2" style="font-size:11px;"
                        [disabled]="currentPage === totalPages" 
                        (click)="onPageChange(currentPage + 1)" title="Next page" aria-label="Next page"><i class="bi bi-chevron-right"></i></button>
                <button class="btn btn-outline-secondary btn-sm py-0 px-2 ms-1" style="font-size:11px;"
                        [disabled]="currentPage === totalPages"
                        (click)="onPageChange(totalPages)" title="Last page" aria-label="Last page"><i class="bi bi-chevron-bar-right"></i></button>
            </div>
        </div>
    </div>

</div>